import React from 'react';
// @ts-expect-error [MIGRATION-SUPPRESSION]: TS7016
import Linkify from 'linkifyjs/react';
import noop from 'lodash/noop';
import GroupWithContext from './group-with-context';
import { UploadFieldWithContext } from './upload-field-with-context';
import SelectFieldWithContext from './select-field-with-context';
import TaxonomyFieldWithContext from './taxonomy-field-with-context';
import { TextFieldWithContext } from './text-field-with-context';
import DateFieldWithContext from './date-field-with-context';
import {
  TYPE_GROUP,
  TYPE_UPLOAD_FIELD,
  TYPE_SELECT_FIELD,
  TYPE_TAXONOMY_FIELD,
  TYPE_TEXT_FIELD,
  TYPE_DATE_FIELD,
  MODE_FEATURES,
  TYPE_CHECKBOX_FIELD,
  TYPE_RADIO_FIELD,
  TYPE_NUMBER_FIELD,
} from '../../../constants';

import type { Element } from '../../../types/form/Element';
import { useModeFeature } from '../../../common/contexts/mode-context';
import { RichTextEditor } from '../../../common/components/rich-text-editor';
import ListFieldWithContext from './list-field-with-context';
import { useFormLogic } from '../../logic-builder/form-logic-handler';
import NumberFieldWithContext from './number-field-with-context';

type Props = {
  element: Element;
};

export const FormElement = (props: Props) => {
  const { element } = props;
  const { id, description, type, visible = true } = element;
  const showRichTextEditor = useModeFeature(MODE_FEATURES.RICH_TEXT_EDITOR);
  useFormLogic();

  if (!visible) return null;

  const renderDescription = () => {
    if (!description) return null;
    return showRichTextEditor ? (
      <RichTextEditor
        data-testid={`${id}-rich-text-description`}
        isReadOnly
        onFocus={noop}
        onSave={noop}
        placeholder=""
        value={description}
      />
    ) : (
      <Linkify tagName="span">{description}</Linkify>
    );
  };

  if (type === TYPE_GROUP) {
    return (
      <GroupWithContext description={renderDescription()} element={element} />
    );
  }

  const formFieldComponentsByType: Record<string, React.ReactNode> = {
    [TYPE_UPLOAD_FIELD]: (
      <UploadFieldWithContext
        description={renderDescription()}
        element={element}
      />
    ),
    [TYPE_SELECT_FIELD]: (
      <SelectFieldWithContext
        description={renderDescription()}
        // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
        element={element}
      />
    ),
    [TYPE_TAXONOMY_FIELD]: (
      <TaxonomyFieldWithContext
        description={renderDescription()}
        element={element}
      />
    ),
    [TYPE_TEXT_FIELD]: (
      <TextFieldWithContext
        description={renderDescription()}
        // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
        element={element}
      />
    ),
    [TYPE_DATE_FIELD]: (
      <DateFieldWithContext
        description={renderDescription()}
        element={element}
      />
    ),
    [TYPE_CHECKBOX_FIELD]: (
      <ListFieldWithContext
        // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
        description={renderDescription()}
        element={element}
      />
    ),
    [TYPE_RADIO_FIELD]: (
      <ListFieldWithContext
        // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
        description={renderDescription()}
        element={element}
      />
    ),
    [TYPE_NUMBER_FIELD]: (
      <NumberFieldWithContext
        // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
        description={renderDescription()}
        // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
        element={element}
      />
    ),
  };

  const formFieldComponent = formFieldComponentsByType[type];

  if (formFieldComponent) {
    return (
      <div data-testid="submitter-form-field-container">
        {formFieldComponent}
      </div>
    );
  }

  return null;
};
